module.exports = __webpack_public_path__ + "0904cead9b3305273aa4377483307fc7.jpg";